"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParseSpeeds = void 0;
var ParseSpeeds;
(function (ParseSpeeds) {
    ParseSpeeds[ParseSpeeds["Fastest"] = Infinity] = "Fastest";
    ParseSpeeds[ParseSpeeds["Fast"] = 1500] = "Fast";
    ParseSpeeds[ParseSpeeds["Medium"] = 500] = "Medium";
    ParseSpeeds[ParseSpeeds["Slow"] = 100] = "Slow";
})(ParseSpeeds = exports.ParseSpeeds || (exports.ParseSpeeds = {}));
//# sourceMappingURL=PDFDocumentOptions.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/pdf-lib/cjs/api/PDFDocumentOptions.js
// module id = 341
// module chunks = 0